import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Languages, LocalStorageKeys } from '../../enums';
import { RecaptchaService } from '../recaptcha-service/recaptcha.service';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private recaptchaService: RecaptchaService,
    private translate: TranslateService
  ) {}

  getLanguageFromLocalStorage(): string {
    return localStorage.getItem(LocalStorageKeys.LANGUAGE);
  }

  setDefaultLanguage = (): void => {
    this.translate.addLangs([Languages.GREEK, Languages.ENGLISH]);

    let defaultLang: string;
    if (localStorage.getItem(LocalStorageKeys.LANGUAGE) === null) {
      defaultLang = Languages.GREEK;
      localStorage.setItem(LocalStorageKeys.LANGUAGE, Languages.GREEK);
    } else {
      defaultLang = localStorage.getItem(LocalStorageKeys.LANGUAGE);
    }

    this.translate.setDefaultLang(defaultLang);
  };

  setRedirectDefaultLanguage(language: string): void {
    if (language) {
      localStorage.setItem(LocalStorageKeys.LANGUAGE, language);
    }
  }

  setRecaptchaLanguage(lang: string): void {
    const recaptchaScript = this.document.getElementById('recaptcha-script');
    if (recaptchaScript) {
      recaptchaScript.parentNode.removeChild(recaptchaScript);
    }
    this.recaptchaService.createRecaptchaScript(lang);
  }
}
